var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.726,
    height: 51.726,
    viewBox: "0 0 51.726 51.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(-948.986 -453.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_66929",
    "data-name": "Trac\\xE9 66929",
    d: "M59.49,49.433v60.943",
    transform: "translate(989.357 380.356) rotate(45)",
    fill: "none",
    stroke: "#796f68",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_66931",
    "data-name": "Trac\\xE9 66931",
    d: "M59.49,49.433v60.943",
    transform: "translate(876.208 464.488) rotate(-45)",
    fill: "none",
    stroke: "#796f68",
    strokeLinecap: "round",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.973be4f42d985ce3a09ace6be4d15390.svg";
export { ForwardRef as ReactComponent };